import React from 'react';
import { Card, CardBody } from '@chakra-ui/react';

interface GridCardProps<T> {
  item: T;
  index: number;
  renderContent: (item: T, index: number) => React.ReactNode;
  onClick?: (item: T) => void;
  minWidth?: string;
  maxWidth?: string;
  minHeight?: string;
  shadow?: string;
  hoverEffect?: boolean;
}

const GridCard = <T,>({
  item,
  index,
  renderContent,
  onClick,
  minWidth = "300px",
  maxWidth = "500px",
  minHeight = "300px",
  shadow = "md",
  hoverEffect = true
}: GridCardProps<T>) => {
  
  const handleClick = () => {
    if (onClick) {
      onClick(item);
    }
  };

  return (
    <Card
      key={index}
      shadow={shadow}
      borderRadius="lg"
      _hover={hoverEffect ? { 
        shadow: 'lg', 
        transform: 'translateY(-2px)', 
        cursor: onClick ? 'pointer' : 'default' 
      } : {}}
      transition="all 0.2s"
      minW={minWidth}
      maxW={maxWidth}
      h="auto"
      minH={minHeight}
      onClick={handleClick}
    >
      <CardBody>
        {renderContent(item, index)}
      </CardBody>
    </Card>
  );
};

export default GridCard;